import type { SlideProps as MuiSlideProps } from '@mui/material';
import { Slide as MuiSlide } from '@mui/material';
import { forwardRef } from 'react';

/** Slide Transition. Based on MUI Slide: https://mui.com/material-ui/transitions/#slide */
export const Slide = forwardRef<HTMLDivElement, MuiSlideProps>((props, ref) => {
  const { children } = props;

  return (
    <MuiSlide data-testid="slide" {...props} ref={ref}>
      {children}
    </MuiSlide>
  );
});
